module.exports = __webpack_public_path__ + "img/heart_ios_802.png";